import { getLogger } from "@core/logging/logger";
import { observable } from "micro-observables";

export class CookiebotManager {
	private readonly logger = getLogger("🍪 [CookiebotManager]");
	private readonly _consentStatistics = observable<boolean>(true);
	consentStatistics = this._consentStatistics.readOnly();

	constructor() {
		window.addEventListener("CookiebotOnConsentReady", () => {
			this.updateConsents();
		});
		this.updateConsents();
	}

	updateConsents(): void {
		const consent = window.Cookiebot?.consent.statistics ?? false;
		this.logger.debug("Statistical consent found to be", consent);
		this._consentStatistics.set(consent);
	}

	openConsentDialog(): void {
		window.Cookiebot?.renew();
	}
}
